import React from 'react';
import { FormattedMessage, MessageValue } from 'react-intl';
import { DEFAULT_MESSAGE } from './defaultMessage.constant';

export class TranslationHelpers {
    public static isMessageDescriptor(
        message: FormattedMessage.MessageDescriptor | string,
    ): message is FormattedMessage.MessageDescriptor {
        return typeof message !== 'string' && Boolean(message.id);
    }

    public static isString(
        message: FormattedMessage.MessageDescriptor | string,
    ): message is string {
        return typeof message === 'string';
    }

    public static getMessageDescriptor(id: string): FormattedMessage.MessageDescriptor {
        return {
            defaultMessage: DEFAULT_MESSAGE[id] || '',
            id,
        };
    }

    public static getFormattedMessage(
        id: string,
        values?: { [key: string]: MessageValue | JSX.Element },
    ): React.ReactElement {
        return (
            <FormattedMessage
                id={id}
                defaultMessage={DEFAULT_MESSAGE[id]}
                values={values}
                tagName={'data'}
            />
        );
    }

    public static getFormattedMessageProps(
        id: string,
        values?: { [key: string]: MessageValue | JSX.Element },
    ): FormattedMessage.Props {
        return {
            ...TranslationHelpers.getMessageDescriptor(id),
            values,
        };
    }
}
